import { Injectable } from '@angular/core';

import { toFixed } from '../../../../core/services/utils/numbers';

@Injectable({
    providedIn: 'root'
})
export class PedidoLiberarCalculoService {
    /** Calcula o percentual excedente do perc. bonificado sobre o perc. bonificação máxima */
    calcularPercExcedenteBonificacao(percBonificacao: number, percBonificacaoMaxima: number): number {
        percBonificacao = percBonificacao && !isNaN(percBonificacao) ? Number(percBonificacao) : 0;
        percBonificacaoMaxima = percBonificacaoMaxima && !isNaN(percBonificacaoMaxima) ? Number(percBonificacaoMaxima) : 0;

        const perc = percBonificacao - percBonificacaoMaxima;
        if (perc <= 0) {
            return 0;
        }

        return toFixed(perc, 2);
    }
}
